import { render, staticRenderFns } from "./Amparo.vue?vue&type=template&id=74948e72&"
import script from "./Amparo.vue?vue&type=script&lang=js&"
export * from "./Amparo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports